export default __webpack_public_path__ + "static/media/Xi Yan.d8dc7914.JPG";